import logo from "../../images/logo_black.svg";

export function LandingFooterComponent() {
  return (
    <div id="contact" className="bg-white pt-24 sm:pt-48 ">
      <div className="border-t border-slate-900/5 py-10">
        <img src={logo} className="w-24 mx-auto" alt="logo" />
        <p className="text-center text-sm leading-6 text-slate-500 mt-6">
          © 2024 GoBarber All rights reserved.
        </p>
        <div className="mt-10 flex w-full px-4 items-center justify-center text-center space-x-4 text-sm font-semibold leading-6 text-slate-700">
          <a href="/privacy-policy">Informativa sulla privacy</a>
          <div className="h-4 w-px bg-slate-500/20"></div>
          <a href="/terms-and-conditions">Termini e condizioni</a>
          <div className="hidden sm:block h-4 w-px bg-slate-500/20"></div>
          <a href="/credits" className="hidden sm:block">
            Crediti
          </a>
        </div>
        <div className="sm:hidden mt-4 flex w-full px-4 items-center justify-center text-center space-x-4 text-sm font-semibold leading-6 text-slate-700">
          <a href="/credits" className="sm:hidden">
            Crediti
          </a>
        </div>
      </div>
    </div>
  );
}
